export default "https://legacy.eskolare-development.com/images/responsible-create.png";